import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../context/useAppContext';
import { useHistory } from 'react-router-dom';
import { Card, Icon } from '@weezevent/nacre';

export default function TemplateEmpty({ isReadOnly = true }) {
    const [{ organization }] = useAppContext();
    const history = useHistory();
    const { t } = useTranslation();

    const handleClick = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/tickets_design/templates/new`);
    }, [history, organization]);

    return (
        <Card.EmptyState
            title={t('ticket.ticket_design.templates.empty.title')}
            subtitle={t('ticket.ticket_design.templates.empty.description')}
            icon={<Icon name="list" />}
            labelButton={t('ticket.ticket_design.create_template.title')}
            onClick={isReadOnly ? null : handleClick}
        />
    );
}
